{
  "meta": {
    "title": "Mingxuan Song",
    "description": "Mingxuan Song — PhD candidate at Peking University. Research: reinforcement learning, sharding blockchain, and large language models; open to internships and collaboration."
  },
  "nav": {
    "home": "🏠 Home",
    "chinese": "🌏 中文",
    "english": "🌏 English",
    "about": "👦🏻 About me",
    "publications": "📚 Publications",
    "news": "📰 News",
    "projects": "🌟 Projects",
    "friends": "🧑‍🤝‍🧑 Friends",
    "contact": "✉️ Contact me"
  },
  "hero": {
    "title": "Hi, my name is <span class=\"text-color-main\">Mingxuan Song</span>.",
    "subtitle": "I'm currently pursuing my PhD at <span class=\"text-color-main\">Peking University</span>, under the supervision of Professor <span class=\"text-color-main\">Zhen Xiao</span>.",
    "cta": "Know more"
  },
  "about": {
    "title": "About me",
    "text1": "I am currently a PhD student in Computer Systems Architecture at the School of Computer Science, Peking University, under the supervision of Professor Zhen Xiao, with an expected graduation in July 2028. I received my bachelor's degree in computer science and technology from China University of Geosciences, Wuhan, in 2023. My research interests include Reinforcement Learning (RL), Large Language Models (LLMs), and Sharding Blockchain.",
    "text2": "My goal is to continuously grow both professionally and personally, while maintaining a healthy and fulfilling lifestyle. I am also actively seeking internship and job opportunities worldwide. Feel free to contact me!",
    "location": "📍 Location: Beijing, China",
    "hobbies": "🎯 Hobbies: 🏸 Badminton | 🎱 Billiards | 🏓 Table Tennis | 🏃‍♂️ Running",
    "viewResume": "View Resume",
    "resumeUrl": "./assets/resumeEN.pdf"
  },
  "publications": {
    "title": "📚 Publications",
    "scholar": "Scholar"
  },
  "news": {
    "title": "📰 News",
    "items": [
      {
        "text": "Summer Practice Activity in Shanghai, organized by the School of Computer Science, Peking University.",
        "report": "[Report]",
        "date": "August 29, 2025"
      },
      {
        "text": "Summer Practice Activity in Hefei, Anhui Province, organized by the School of Computer Science, Peking University.",
        "report1": "[Report 1]",
        "date1": "July 30, 2025",
        "report2": "[Report 2]",
        "date2": "August 5, 2025"
      },
      {
        "text": "Joint Introductory Computing Tutorial Successfully Held by Ten Institutes, Peking University.",
        "report": "[Report]",
        "date1": "December 23, 2024",
        "preview": "[Preview]",
        "date2": "December 12, 2024"
      },
      {
        "text": "Summer Practice Activity in Mianyang, Sichuan Province, organized by the School of Computer Science, Peking University.",
        "report": "[Report]",
        "date": "July 19, 2024"
      },
      {
        "text": "Outstanding Undergraduate Graduates of the Class of 2023, China University of Geosciences (Wuhan).",
        "link": "[Link]",
        "date": "June 19, 2023"
      },
      {
        "text": "Public List of Peking University 2023 Recommended Exempted Postgraduate Candidates, Peking University.",
        "link": "[Link]",
        "date": "November 1, 2022"
      },
      {
        "text": "The Second Professional Vertical Communication Forum of School of Computer Science, China University of Geosciences (Wuhan).",
        "link": "[Link]",
        "date": "October 3, 2022"
      },
      {
        "text": "2022 Summer Camp for Outstanding Students, School of Computer Science, Peking University.",
        "admissionResult": "[Admission Result]",
        "date1": "September 30, 2022",
        "outstandingList": "[List of Outstanding Participants]",
        "date2": "July 8, 2022",
        "admissionNotice": "[Admission Notice]",
        "date3": "June 28, 2022"
      },
      {
        "text": "The Second Professional Vertical Communication Forum of the School of Computer Science, School of Computer Science, China University of Geosciences (Wuhan).",
        "link": "[Link]",
        "date": "September 27, 2022"
      },
      {
        "text": "Class 111003 Senior Scholarship, School of Computer Science, China University of Geosciences (Wuhan).",
        "link": "[Link]",
        "date": "June 21, 2022"
      },
      {
        "text": "Award List of the 2021 National Undergraduate Mathematical Contest in Modeling (MCM Cup).",
        "link": "[Link]",
        "date": "November 15, 2021"
      },
      {
        "text": "National College Student Innovation Training Program Platform.",
        "link": "[Link]",
        "date": "August 24, 2021"
      },
      {
        "text": "Public List of National Scholarship Candidates for Undergraduates (2019-2020 Academic Year), China University of Geosciences (Wuhan).",
        "link": "[Link]",
        "date": "November 2, 2020"
      }
    ]
  },
  "projects": {
    "title": "🌟 Projects",
    "project1": {
      "title": "Few-Shot RL Fine-Tuning for LLMs",
      "affiliations": "Affiliations:",
      "affiliation1": "School of Computer Science, Peking University;",
      "affiliation2": "Alimama, Alibaba Group.",
      "description": "In recent years, Large Language Models (LLMs) have demonstrated remarkable performance across a variety of natural language processing tasks. However, fine-tuning these models typically requires large-scale datasets and extensive computational resources, which limits their applicability in scenarios where data is scarce and budgets are constrained. This work explores a novel approach to few-shot reinforcement learning (RL) fine-tuning for LLMs, aiming to adapt pre-trained models to specific tasks using minimal supervision."
    },
    "project2": {
      "title": "RL for Efficient Sharding Blockchain",
      "affiliations": "Affiliations:",
      "affiliation1": "School of Computer Science, Peking University;",
      "affiliation2": "Theta Labs, Theta Inc.",
      "description": "Sharding blockchain systems face critical challenges in achieving efficient cross-shard data distribution and maintaining balanced workload across shards. Traditional address allocation methods often suffer from high latency and uneven shard utilization, especially when dealing with dynamically changing transaction patterns and reconfiguration events."
    },
    "project3": {
      "title": "Evolutionary RL for Sensor Placement in Water Supply Networks",
      "affiliations": "Affiliations:",
      "affiliation1": "School of Computer Science, China University of Geosciences, Wuhan.",
      "description": "In water supply networks, effective sensor placement is critical for early detection of contamination events, yet practical deployments are constrained by limited sensor budgets and scarce historical contamination data. This work investigates an evolutionary reinforcement learning formulation of the sensor placement problem, modeling it as a sequential decision-making process under limited supervision. By incorporating domain knowledge into an evolutionary reinforcement learning framework, the proposed approach enables efficient optimization."
    }
  },
  "friends": {
    "title": "🧑‍🤝‍🧑 Friends"
  },
  "contact": {
    "title": "✉️ Contact me",
    "email": "📧 Email: songmingxuan@stu.pku.edu.cn",
    "wechat": "💬 WeChat: smx-scholar",
    "cta": "Call to Action"
  },
  "footer": {
    "text": "© 2025 - Developed by Mingxuan Song"
  }
}

